// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Box[data-v-01a43d97] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.right[data-v-01a43d97] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.Box[data-v-01a43d97]  .el-divider {\n  margin: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
